(function () {
    'use strict';

    const VERSION = 'shopify-common-2026-07';
    const script = document.currentScript;
    const brandCode = script && script.dataset.signalBrand || '';
    const mappings = [
        ['a[href="/cart"], a[href^="/cart?"]', 'header.cart', 'header', 'open_cart', false],
        ['form[action*="/cart/add"]', 'product.form', 'product_form', 'submit', false],
        ['form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] [type="submit"]', 'product.add_to_cart', 'product_form', 'add_to_cart', true],
        ['form[action*="/cart/add"] [name="quantity"], .quantity input', 'product.quantity', 'product_form', 'change_quantity', false],
        ['variant-selects, variant-radios, form[action*="/cart/add"] select[name="id"]', 'product.variant_selector', 'product_form', 'select_variant', false],
        ['#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]', 'cart.checkout', 'cart', 'checkout', true]
    ];

    function announcePrivacyApi() {
        if (window.Shopify && window.Shopify.customerPrivacy) {
            document.dispatchEvent(new CustomEvent('shopifyCustomerPrivacyApiLoaded'));
        }
    }

    function loadPrivacyApi() {
        if (window.Shopify && window.Shopify.customerPrivacy) {
            announcePrivacyApi();
            return;
        }
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([
            { name: 'consent-tracking-api', version: '0.1' }
        ], function (error) {
            if (!error) announcePrivacyApi();
        });
    }

    function annotate(root) {
        mappings.forEach(function (mapping) {
            (root || document).querySelectorAll(mapping[0]).forEach(function (node) {
                node.dataset.signalComponent = mapping[1];
                node.dataset.signalRegion = mapping[2];
                node.dataset.signalAction = mapping[3];
                node.dataset.signalAdapterVersion = VERSION;
                if (mapping[4]) node.dataset.signalDeadcheck = 'true';
            });
        });
        if (brandCode === 'SFT') {
            (root || document).querySelectorAll('form[action*="/contact"], form[data-form-id]').forEach(function (form) {
                form.dataset.signalForm = 'lead_form';
                form.dataset.signalComponent = 'lead.form';
                form.dataset.signalRegion = 'form';
                form.dataset.signalAdapterVersion = VERSION;
            });
        }
    }

    annotate(document);
    loadPrivacyApi();
    new MutationObserver(function () { annotate(document); }).observe(document.documentElement, {
        childList: true, subtree: true
    });
})();
